import Text from 'components/Text';
import type { CustomizationPlacement } from 'models/api';
import { cn } from 'utils/classNames';
import { is } from 'utils/helpers';

interface Props {
	className?: string;
	placements: CustomizationPlacement[] | undefined;
}

export default function BasketRowPrintInfo({ className, placements }: Props) {
	if (!is.arrayWithLength(placements)) {
		return null;
	}

	return (
		<ul className={cn('space-y-4', className)}>
			{placements.map((placement) => (
				<li key={placement.id}>
					<Text as="pSmall" text={placement.title} />
					<Text as="pSmall" text={placement.option?.text} />
					<Text
						as="pSmall"
						text={placement.printImageFilename?.originalFileName}
					/>
				</li>
			))}
		</ul>
	);
}
BasketRowPrintInfo.displayName = 'BasketRowPrintInfo';
